import { createSelector } from '@ngrx/store';
import { State } from '@store/state';

const getDashboard = (state: State) => state.dashboard;

// Get all filters data
export const getAllowedUserProductIdList = createSelector(
  getDashboard,
  (state) => state.filters.allData.productIdList
);
export const getEventTypeList = createSelector(
  getDashboard,
  (state) => state.filters.allData.eventTypeList.data
);
///

// Get current filters
export const getDashboardFilters = createSelector(
  getDashboard,
  (state) => state.filters.dashboardFilter
);
///

// Histogram sent mail
export const getHistogramMailSentApiCall = createSelector(
  getDashboard,
  (state) => state.chartData.histogramMailSent
);
export const getHistogramMailSentData = createSelector(
  getDashboard,
  (state) => state.chartData.histogramMailSent.data
);

// Deliverability Indicators
export const getDeliverabilityIndicatorsApiCall = createSelector(
  getDashboard,
  (state) => state.chartData.deliverabilityIndicators
);

// Thresholds
export const getThresholdsApiCall = createSelector(
  getDashboard,
  (state) => state.chartData.thresholds
);

// Providers Stats
export const getProvidersStatsApiCall = createSelector(
  getDashboard,
  (state) => state.chartData.providersStats
);